import { createStore } from 'vuex'
import axios from 'axios'

export default createStore({
  state: {
    user: JSON.parse(localStorage.getItem('user')) || null,
    token: localStorage.getItem('token') || null,
    devices: [],
    // 设备分页状态
    devicesPage: 0,
    devicesSize: 15,
    devicesTotal: 0,
    devicesTotalPages: 0,
    users: []
  },
  getters: {
    isAuthenticated: state => !!state.token,
    isAdmin: state => state.user?.role === 'ADMIN' || state.user?.role === 'admin',
    currentUser: state => state.user
  },
  mutations: {
    SET_USER(state, user) {
      state.user = user
      localStorage.setItem('user', JSON.stringify(user))
    },
    SET_TOKEN(state, token) {
      state.token = token
      localStorage.setItem('token', token)
    },
    CLEAR_AUTH(state) {
      state.user = null
      state.token = null
      localStorage.removeItem('user')
      localStorage.removeItem('token')
    },
    SET_DEVICES(state, devices) {
      state.devices = Array.isArray(devices) ? devices : []
    },
    // 新增：设置设备分页元数据
    SET_DEVICE_PAGINATION(state, { page, size, total, totalPages }) {
      if (page !== undefined) state.devicesPage = page
      if (size !== undefined) state.devicesSize = size
      if (total !== undefined) state.devicesTotal = total
      if (totalPages !== undefined) state.devicesTotalPages = totalPages
    },
    SET_USERS(state, users) {
      state.users = Array.isArray(users) ? users : []
    },
    ADD_DEVICE(state, device) {
      state.devices.push(device)
    },
    UPDATE_DEVICE(state, updatedDevice) {
      const index = state.devices.findIndex(d => d.id === updatedDevice.id)
      if (index !== -1) {
        state.devices.splice(index, 1, updatedDevice)
      }
    },
    DELETE_DEVICE(state, deviceId) {
      state.devices = state.devices.filter(d => d.id !== deviceId)
    }
  },
  actions: {
    async login({ commit }, credentials) {
      const response = await axios.post('/api/admin/login', credentials)
      
      if (!response.data) {
        throw new Error('服务器返回数据为空')
      }
      
      const { token, user } = response.data
      
      if (!token) {
        throw new Error('服务器未返回token')
      }
      
      if (!user) {
        throw new Error('服务器未返回用户信息')
      }
      
      commit('SET_TOKEN', token)
      commit('SET_USER', user)
      return response
    },
    logout({ commit }) {
      commit('CLEAR_AUTH')
    },
    async fetchDevices({ commit }, payload = {}) {
      try {
        const { page = 0, size = 15, keyword = '' } = payload
        const response = await axios.get('/api/admin/devices', {
          params: { page, size, keyword }
        })

        // 后端返回格式: { success: true, data: [...], total, page, size, totalPages }
        const devices = response.data?.data || []
        const total = response.data?.total ?? devices.length
        const respPage = response.data?.page ?? page
        const respSize = response.data?.size ?? size
        const totalPages = response.data?.totalPages ?? Math.ceil(total / respSize)

        commit('SET_DEVICES', devices)
        commit('SET_DEVICE_PAGINATION', {
          page: respPage,
          size: respSize,
          total,
          totalPages
        })
        return response
      } catch (error) {
        commit('SET_DEVICES', [])
        commit('SET_DEVICE_PAGINATION', { page: 0, size: 15, total: 0, totalPages: 0 })
        throw error
      }
    },
    async addDevice({ commit }, device) {
      const response = await axios.post('/api/admin/devices', device)
      // 后端返回格式: { success: true, message: "...", data: {...} }
      const newDevice = response.data.data
      commit('ADD_DEVICE', newDevice)
      return response
    },
    async updateDevice({ commit }, device) {
      const response = await axios.put(`/api/admin/devices/${device.id}`, device)
      // 后端返回格式: { success: true, message: "...", data: {...} }
      const updatedDevice = response.data.data
      commit('UPDATE_DEVICE', updatedDevice)
      return response
    },
    async deleteDevice({ commit }, deviceId) {
      await axios.delete(`/api/admin/devices/${deviceId}`)
      commit('DELETE_DEVICE', deviceId)
    },
    async fetchUsers({ commit }) {
      try {
        const response = await axios.get('/api/admin/users')

        // 后端返回的数据结构是 {success: true, data: users, total: count}
        const users = response.data.data || []
        commit('SET_USERS', users)
        return response
      } catch (error) {
        commit('SET_USERS', [])
        throw error
      }
    },
    async request({ state }, { url, method = 'GET', data = null }) {
      const config = {
        method,
        url,
        headers: {}
      }
      
      if (state.token) {
        config.headers.Authorization = `Bearer ${state.token}`
      }
      
      if (data) {
        config.data = data
      }
      
      const response = await axios(config)
      return response.data
    }
  }
})